import React, {Fragment} from 'react';
import {I18n} from '../i18n/I18n';

export const TaxIncluded = ({openModal}) => (
  <Fragment>
    <I18n t='zzgl.' /> <I18n t='Kurtaxe vor Ort' class='popup-action' onClick={openModal} />
  </Fragment>
);
